import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import Icon from 'components/Icon';

type MagicLinkSuccessProps = {
    emailAddress: string;
};

const MagicLinkSuccess: FC<MagicLinkSuccessProps> = ({emailAddress}) => {
    const {t} = useTranslation('Portal');

    return (
        <div>
            <h1 className="mt-2 flex">
                <Icon className="my-0.5 mr-2 text-green-500" icon="success" />
                {t('login.successTitle')}
            </h1>
            <div className="sm:ml-8 pb-4 pt-2">
                <p className="mb-4">
                    {t('login.successMessage', {
                        email: emailAddress,
                    })}
                </p>
                <div className="mb-4 flex">
                    <Icon
                        className="my-0.5 mr-2 text-gold-700"
                        icon="warning"
                        size="base"
                    />
                    {t('login.linkExpirationWarning')}
                </div>
                <p className="mb-2 text-sm text-grey-600">
                    {t('login.troubleshootingTitle')}
                </p>
                <ul className="text-sm text-grey-600">
                    <li>{t('login.troubleshootingEmail')}</li>
                    <li>{t('login.troubleshootingSpam')}</li>
                    <li>{t('login.troubleshootingDomain')}</li>
                    <li>{t('login.troubleshootingPersonalEmail')}</li>
                </ul>
            </div>
            <div className="mt-8 flex flex-row justify-end gap-4">
                <Button
                    aria-label="try-again"
                    className="border-transparent text-left text-green-700"
                    kind="custom"
                    onClick={() => window.history.back()}
                >
                    {t('login.tryAgain')}
                </Button>
            </div>
        </div>
    );
};

export default MagicLinkSuccess;
